import axios from "axios";
import { getHeaders } from '../helpers';
import { getChestApiUrl } from "../../helpers";

const url = `${getChestApiUrl()}/chestApi/address`

/**
 * Get Addresss from user.
 * 
 * @param {String} params.session Id of the user in the database
 */
const getAddress = params => axios({ method: 'get', url, headers: getHeaders(), params })

/**
 * Add Address to user.
 * 
 * @param {String} data.userId Id of the user in the database
 * @param {String} data.address Address data to add
 */
const addAddress = data => axios({ method: 'post', url, headers: getHeaders(), data })

/**
 * Update Addres from user.
 * 
 * @param {String} data.userId Id of the user in the database
 * @param {String} data.address Address data to add
 */
const updateAddress = data => axios({ method: 'put', url, headers: getHeaders(), data })

export default { getAddress, addAddress, updateAddress }